import { TCancelPromiseKey } from './types';

export const CANCEL_PROMISE_KEY: TCancelPromiseKey =
  '@@redux-saga/CANCEL_PROMISE';
